import { useReducer } from 'react';
import { SearchContext } from '../types';
import { QueryBuilderFilterDefinitionGroup } from '../filterUtils';
import { DEFAULT_STATE, queryBuilderReducer } from './reducer';
import { ActionType } from './reducerTypes';
import { fillEmptyQueries, queryToReducerState } from './utils';
import { QueryBuilderSubquery } from '@ardoq/api-types';
import {
  AddRow,
  MoveRow,
  RemoveRow,
  UpdateRow,
  UpdateSearchContext,
} from './types';

export const useQueryBuilderReducer = (
  initialQuery: QueryBuilderSubquery | undefined,
  initialSearchContext: SearchContext,
  filterGroups: QueryBuilderFilterDefinitionGroup[],
  maxSubqueryNestingLevel: number
) => {
  const [queryBuilderState, dispatch] = useReducer(
    queryBuilderReducer,
    initialQuery
      ? queryToReducerState(
          initialSearchContext,
          initialQuery,
          filterGroups,
          maxSubqueryNestingLevel
        )
      : fillEmptyQueries({
          ...DEFAULT_STATE,
          searchContext: initialSearchContext,
          maxSubqueryNestingLevel,
        })
  );

  const addRow: AddRow = params =>
    dispatch({ type: ActionType.ADD_ROW, ...params });
  const removeRow: RemoveRow = params =>
    dispatch({ type: ActionType.REMOVE_ROW, ...params });
  const updateRow: UpdateRow = (uuid, params) =>
    dispatch({ type: ActionType.UPDATE_ROW, uuid, ...params });
  const updateSearchContext: UpdateSearchContext = searchContext =>
    dispatch({ type: ActionType.UPDATE_SEARCH_CONTEXT, searchContext });
  const moveRow: MoveRow = params =>
    dispatch({ type: ActionType.MOVE_ROW, ...params });

  return {
    queryBuilderState,
    reducerActions: {
      addRow,
      removeRow,
      updateRow,
      updateSearchContext,
      moveRow,
    },
  };
};
